export interface GetUserReserveCancelCollectionsRequest {
  id: string
}

export function GetUserReserveCancelCollectionsRequestToJSON(
  value: GetUserReserveCancelCollectionsRequest
): any {
  return {
    id: value.id !== '' ? value.id : undefined
  }
}
